var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.itemList.length > 0 || _vm.scrollFlag)?[_c('div',{staticClass:"list_box"},_vm._l((_vm.itemList),function(item){return _c('Item',{key:item.articleId,attrs:{"details":item}})}),1),_c('Scroll',{attrs:{"scrollFlag":_vm.scrollFlag,"isEnd":_vm.isEnd}})]:_vm._e(),(_vm.itemList.length == 0 && !_vm.scrollFlag)?_c('NoData'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }